import * as actions from '../actionTypes'

// initial state is no items selected
// each item is:
// {
//    id: story document id
//    label: story name
// }

const initialState = { 
    value: []
}

export default function storyGridSelectedItems(state = initialState, action) {

    switch(action.type) {

        case actions.SET_STORY_GRID_SELECTED_ITEMS: {

            //console.log('[redux] Setting story grid selected items', action.payload)
            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}